import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=7df4a856&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=7df4a856&prod&scoped=true&lang=scss"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=7df4a856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4a856",
  null
  
)

export default component.exports